module.exports = __webpack_public_path__ + "static/media/close.ccffa310.svg";